// Célula padronizada — folha escaneada (prova objetiva / redação, admin)

import React from 'react';
import { styles } from '../../styles/globalStyles';

/** URL autenticada para abrir o PDF (evita SPA/static quebrado e PDF inválido em cache). */
export const examScanFileHref = (applicationId, scanKind = 'objective') => {
  if (!applicationId) return null;
  const base =
    scanKind === 'essay'
      ? `/api/applications/${applicationId}/exam_essay_scan/file`
      : `/api/applications/${applicationId}/exam_objective_scan/file`;
  return base;
};

/** Link “Ver PDF” padronizado (admin e analista). */
export const ExamScanPdfLink = React.memo(({ scanUrl, applicationId, scanKind = 'objective' }) => {
  const href = applicationId ? examScanFileHref(applicationId, scanKind) : scanUrl;
  return href ? (
    <a href={href} target="_blank" rel="noopener noreferrer" style={{ fontSize: 12, color: '#1D4ED8' }}>
      Ver PDF
    </a>
  ) : (
    '—'
  );
});

/**
 * Padrão único: Ver PDF (12px) + Substituir/Remover (10px, padding 4px 8px) ou Enviar PDF (11px, padding 4px 10px).
 * Referência: ExamObjectiveAdminPage — reutilizar em qualquer coluna de folha PDF.
 */
export const ExamScanCellActions = React.memo(
  ({
    scanUrl,
    appId,
    scanBusy,
    onUpload,
    onRemove,
    allowRemove = true,
    uploadDisabled = false,
    uploadDisabledTitle,
    scanKind = 'objective',
  }) => {
    const busy = scanBusy === appId;
    const blocked = uploadDisabled && !scanUrl;
    const pickFile = () => {
      if (blocked) return;
      onUpload(appId);
    };
    const btnTitle = blocked ? uploadDisabledTitle : undefined;
    return (
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, alignItems: 'center' }}>
        {scanUrl ? (
          <>
            <ExamScanPdfLink scanUrl={scanUrl} applicationId={appId} scanKind={scanKind} />
            <button
              type="button"
              onClick={pickFile}
              disabled={busy || uploadDisabled}
              title={uploadDisabled ? uploadDisabledTitle : undefined}
              style={{ ...styles.button, ...styles.buttonSecondary, fontSize: 10, padding: '4px 8px' }}
            >
              Substituir
            </button>
            {allowRemove && onRemove && (
              <button
                type="button"
                onClick={() => onRemove(appId)}
                disabled={busy}
                style={{ ...styles.button, ...styles.buttonDanger, fontSize: 10, padding: '4px 8px' }}
              >
                Remover
              </button>
            )}
          </>
        ) : (
          <button
            type="button"
            onClick={pickFile}
            disabled={busy || blocked}
            title={btnTitle}
            style={{
              ...styles.button,
              ...styles.buttonPrimary,
              fontSize: 11,
              padding: '4px 10px',
              opacity: blocked ? 0.55 : 1,
              cursor: blocked ? 'not-allowed' : busy ? 'wait' : 'pointer',
            }}
          >
            {busy ? 'Enviando…' : 'Enviar PDF'}
          </button>
        )}
      </div>
    );
  }
);
